import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function fetchWithTimeout(resource, options = {}, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("Request timed out"));
    }, timeout);

    fetch(resource, options)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
}


const getLocationName = async (coordString) => {
  const coords = coordString?.split(",");
  if (!coords || coords.length !== 2) throw new Error("Invalid location");

  const lat = coords[0].trim();
  const lon = coords[1].trim();

  if (isNaN(lat) || isNaN(lon)) throw new Error("Invalid coordinates");

  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;

  const response = await fetchWithTimeout(url, {}, 5000);
  const data = await response.json();

  if (!data?.display_name) throw new Error("No location found");

  return data.display_name;
};

function OrgLocationModal({
  isOpenOrgLocation,
  setIsOpenOrgLocation,
  setIsOpenLocationPickerModal,
  setIsLocationEdit,
  orggpscoordinates,
  setSelectedLocation,
  setIsOpenRangePicker,
  S,
  RedpinIcon
}) {
  console.log(orggpscoordinates,"orggpscoordinates")
  const [resolvedLocations, setResolvedLocations] = useState({});
  const resolvedRef = useRef({}); 

  useEffect(() => {
    resolvedRef.current = resolvedLocations;
  }, [resolvedLocations]);

  const resolveAllLocations = async () => {
    for (const location of orggpscoordinates) {
      if (resolvedRef.current[location.locationid]?.status === "success") continue;

      const coordString = `${location.lat},${location.lng}`;

      try {
        const locationName = await getLocationName(coordString);

        setResolvedLocations((prev) => ({
          ...prev,
          [location.locationid]: {
            status: "success",
            value: locationName
          }
        }));
      } catch (err) {
        setResolvedLocations((prev) => ({
          ...prev,
          [location.locationid]: {
            status: "error",
            value: "Error fetching location"
          }
        }));
      }

     
      await new Promise((res) => setTimeout(res, 1000));
    }
  };

  useEffect(() => {
    if (!isOpenOrgLocation || !orggpscoordinates.length) return;

    setResolvedLocations((prev) => {
      const updated = { ...prev };

      orggpscoordinates.forEach((loc) => {
        if (!updated[loc.locationid]) {
          updated[loc.locationid] = { status: "loading", value: "" };
        }
      });

      return updated;
    });

    resolveAllLocations();

  }, [isOpenOrgLocation, orggpscoordinates]);

  return (
    <Modal
      show={isOpenOrgLocation}
      onHide={() => setIsOpenOrgLocation(false)}
      style={{ backgroundColor: "rgba(0,0,0,0.85)" }}
      centered
      keyboard={false}
      backdrop="static"
      size="md"
      scrollable
    >
      <Modal.Body style={{ padding: 0, borderRadius: 16, overflow: "hidden" }}>
        <div>
         
          <div style={S.locHeader}>
            <span style={{color:"#29b6f6"}}>Organisation locations</span>
            <IconButton
              size="small"
              style={{ color: "#111", background: "#f0f0f0" }}
              onClick={() => {
                setIsOpenLocationPickerModal(true);
                setIsLocationEdit(false);
              }}
            >
              <AddIcon style={{color:"#29b6f6"}} fontSize="small" />
            </IconButton>
          </div>

         
          <div style={S.locBody}>
            {orggpscoordinates.length === 0 && (
              <div
                style={{
                  padding: "20px 18px",
                  color: "#aaa",
                  fontSize: 13,
                  textAlign: "center"
                }}
              >
                No locations added yet
              </div>
            )}

            {orggpscoordinates.map((location) => {
                console.log(location,"locatioedfwgxhksjlfdghjks")
              const locState = resolvedLocations[location.locationid];

              let displayText = "Fetching location...";

              if (locState?.status === "error") {
                displayText = locState.value;
              } else if (locState?.status === "success") {
                displayText = locState.value;
              }

              return (
                <div
                  key={location.locationid}
                  style={S.locRow}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f7f7f7")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                  onClick={() => {
                    setSelectedLocation(location);
                    setIsOpenRangePicker(true);
                  }}
                >
                
                  <div style={{ display: "flex", alignItems: "start",flexDirection:"column"}}>
                   
  <div style={{display:"block"}}>{location.locationname}</div>
                    <span style={S.locCoord}>{displayText}</span>
                  </div>

                  <span style={S.locRange}>{location.range}m</span>
                </div>
              );
            })}
          </div>
          <div style={S.locFooter}>
            <button
              style={S.okBtn}
              onClick={() => setIsOpenOrgLocation(false)}
            >
             Ok
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OrgLocationModal;